import AuditNav from "../../pages/Dashboard/Audit/AuditNav";
import AuditIndex from "../../pages/Dashboard/Audit/AuditIndex";
import AuditLogsList from "../../pages/Dashboard/Audit/AuditLogs/AuditLogsList";
import AuditRequestsList from "../../pages/Dashboard/Audit/AuditRequests/AuditRequestsList";

const auditRoutes = {
  path: "/audit",
  element: <AuditNav />,
  children: [
    { path: "/audit", element: <AuditIndex /> },
    { path: "/audit/logs", element: <AuditLogsList /> },
    { path: "/audit/requests", element: <AuditRequestsList /> },
  ],
};

export default auditRoutes;

